import React from 'react'
import { Grid, Button } from '@mui/material';
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";


export default function PreviewButton({
    confirmar,
    facturarDeshabilitado
}) {

    return (
        <div>
            <Grid item xs={12} md="auto">
                <Button
                    variant="contained"
                    color="success"
                    fullWidth
                    size="large"
                    startIcon={<CheckCircleOutlineIcon />}
                    onClick={confirmar}
                    disabled={facturarDeshabilitado}
                    sx={{
                        minWidth: { md: 200 },
                        py: 1.25,
                        fontWeight: 700,
                        borderRadius: 2,
                        boxShadow: "none",
                    }}
                >
                    PREVISUALIZAR
                </Button>
            </Grid>
        </div>
    )
}



